import { render, staticRenderFns } from "./InstructionsStart.vue?vue&type=template&id=287e1435&scoped=true&"
import script from "./InstructionsStart.vue?vue&type=script&lang=js&"
export * from "./InstructionsStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e1435",
  null
  
)

export default component.exports